import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { BaseComponent } from "BaseComponent";
import LocaleStrings from "Languages";
import { converDateIntoLocalwithmonth } from "Constants";

class AdvertisementuserlistModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            btnLoading: false
        };
    }
    closeModals = () => {
        this.props.reset();
        this.props.onClose();
    };

    renderusersList = (e) => {
        let { row_data } = this.props;
        let item = _.map(row_data.userlist, (val, index) => {
            return (
                <tr
                    key={index} id={index}
                >
                    <td>
                        <div
                            className="row"
                            style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
                        >
                            {val.username}
                        </div>
                    </td>
                    <td>
                        <div
                            className="row"
                            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                        >
                            {val.email}
                        </div>
                    </td>
                    <td>
                        <div
                            className="row"
                            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                        >
                            {converDateIntoLocalwithmonth(val.timestamp).format("D MMM YYYY HH:mm A")}
                        </div>
                    </td>
                </tr>
            );
        })

        return item;
    };


    render() {
        let { clientdataforbilling, row_data } = this.props;

        return (
            <Modal
                show={this.props.isOpen}
                onHide={this.closeModals}
                className=""
                dialogClassName="billing-payement-modal"
            >
                <Modal.Header >
                    <Modal.Title>
                        <div className="title-modal">View Users</div>
                    </Modal.Title>
                    <button
                        type="button"
                        className="i-custom-cross-popup pull-right"
                        onClick={this.closeModals}
                    >
                        <img
                            className="i-custom-small"
                            src="../../style/images/custom-icons/cross-black.png"
                        />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {row_data && row_data.userlist.length > 0 ?
                        (
                            <div
                                className="panel-body scrollable-content"
                            // style={{ height: deviceSize.height - 175 }}
                            >

                                <div className="">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th align="center">
                                                    {LocaleStrings.analytics_ad_viewuser_th1}
                                                </th>
                                                <th align="center">
                                                    {LocaleStrings.analytics_ad_viewuser_th2}
                                                </th>
                                                <th align="center">
                                                    {LocaleStrings.analytics_ad_viewuser_th3}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="tbody-background">
                                            {this.renderusersList()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (

                            <div>No Users</div>
                        )}

                </Modal.Body>

            </Modal>
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        session: state.session,
        row_data: ownProps.data
    };
}
export default connect(mapStateToProps, {

})(
    reduxForm({
        form: "AdvertisementuserlistModalForm",
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
    })(AdvertisementuserlistModal)
);